module.exports = __webpack_public_path__ + "static/media/internacional-de-seguros-parking-selected.682bf1a8.svg";